import type { Component } from 'vue'

import { onScopeDispose } from 'vue'

import type {
  ModalConfig,
  ModalEntry,
  ModalRegistration,
  StoredRegistration,
} from '~/composables/modalIsolated'

export const useModal = () => {
  const activeModal = useState<ModalEntry | undefined>('modal-manager-store', () => undefined)
  const registrations = useState<StoredRegistration[]>('modal-manager-registrations', () => [])
  const { currentRoute } = useRouter()

  const manager = useModalIsolated(activeModal, registrations)

  const openModal = <C extends Component>(config: ModalConfig<C>) =>
    manager.openModal({ ...config, routePath: currentRoute.value.path })

  const registerModal = <C extends Component>(registration: ModalRegistration<C>) => {
    if (import.meta.server) return { close: () => {}, id: registration.id ?? '' }

    const { id, unregister } = manager.registerModal(registration)
    onScopeDispose(unregister)

    return { close: unregister, id }
  }

  return { ...manager, openModal, registerModal }
}
